import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const LayoutRoot = styled(Box)({
  display: 'flex',
  height: '100vh',
  overflow: 'hidden',
  backgroundColor: '#F5F4FB',
  // backgroundColor: '#f4f5f6',
});

export const BodyArea = styled(Box)({
  display: 'flex',
  flexGrow: 1,
  overflow: 'hidden',
  margin: '12px',
  gap: '30px',
});

export const SidebarWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  // padding: theme.spacing(0.5),
  flexShrink: 0,
}));

export const MainArea = styled('main')({
  flexGrow: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const ContentArea = styled(Box)(({ theme }) => ({
  marginTop: 0,
  marginLeft: theme.spacing(1.5),
  marginRight: theme.spacing(1.5),
  marginBottom: theme.spacing(1.5),
  flexGrow: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': { display: 'none' },
}));
